import styles from "./SearchTabs.module.scss";
import classnames from "classnames";

export const MODEL_TAB = 0;
export const IMEI_TAB = 1;

type TabProps = {
  active: boolean;
  onClick: () => void;
  label: string;
  dataCy?: string;
};

type SearchTabsProps = {
  activeTab?: number;
  onClickTab?: (MODEL_TAB: number) => void;
};

const Tab = ({ active, onClick, label, dataCy }: TabProps) => (
  <button
    className={classnames(
      styles.searchTabs__tab,
      active && styles["searchTabs__tab--active"],
    )}
    onClick={onClick}
    data-cy={dataCy}
  >
    {label}
  </button>
);

const SearchTabs = ({ activeTab = MODEL_TAB, onClickTab }: SearchTabsProps) => (
  <div className={styles.searchTabs} data-test-id="search-tabs">
    <Tab
      label="Search by Model"
      onClick={() => onClickTab?.(MODEL_TAB)}
      active={activeTab === MODEL_TAB}
      dataCy="model-tab"
    />
    <Tab
      label="Search by IMEI"
      onClick={() => onClickTab?.(IMEI_TAB)}
      active={activeTab === IMEI_TAB}
      dataCy="imei-tab"
    />
  </div>
);

export default SearchTabs;
